export const UEFA_IMG_BASE_URL = 'https://img.uefa.com';
